import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRouteForModule } from '@/common/route/registerModules';
import { CollectionType } from '@/modules/collection/types';
import router, { ROUTE_NAME_COLLECTION } from './router';

export default registerRouteForModule(router);

menuRegistry.registerMenu([
    {
        parent: 'Puzzle',
        key: 'Collection',
        name: 'Collection',
        icon: 'fas fa-swatchbook'
    },
    {
        parent: 'Puzzle.Collection',
        key: 'Journey',
        name: 'Journey',
        icon: 'fas fa-route',
        route: { name: ROUTE_NAME_COLLECTION.INDEX(CollectionType.Journey) }
    },
    {
        parent: 'Puzzle.Collection',
        key: 'Gallery',
        name: 'Gallery',
        icon: 'fas fa-images',
        route: { name: ROUTE_NAME_COLLECTION.INDEX(CollectionType.Theme) }
    }
]);
